<script setup>
import { ref } from 'vue'
import GbButton from '@/components/GbButton.vue'
import GbDialog from '@/components/GbDialog.vue'
import { useRouterStore } from '@/router/router.store.ts'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/dialog'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'

const showDialog = ref(false)

const routerStore = useRouterStore()

const dialogId = 'dlg'

function showLoginModalNow() {
  routerStore.forceRelogin()
}

// Dialog form state
const name = ref('')
const email = ref('')
const selectedCategory = ref(null)
const categories = ref([
  { name: 'Category 1', id: 1 },
  { name: 'Category 2', id: 2 },
  { name: 'Category 3', id: 3 },
])
</script>
<template>
  <div class="card flex justify-center">
    <GbButton
      label="Show Base Dialog"
      gbTheme="bluePrimary"
      @click="showDialog = true"
      @update:visible="(newVal) => (showDialog = newVal)"
      class="m-3"
    />

    <GbButton
      label="Show LoginModal"
      gbTheme="bluePrimary"
      @click="showLoginModalNow"
      class="m-3"
    />

    <GbDialog :dialogId="dialogId" v-model:visible="showDialog" header="Dialog title" :footer-buttons="true">
      <template #bodyContent>
        <p>Some text would go here.</p>
      </template>
      <template #footerButtonLeft>
        <GbButton
          type="button"
          gbTheme="grayOutlineSecondary"
          label="Cancel"
          @click="showDialog = false"
        ></GbButton>
      </template>
      <template #footerButtonRight>
        <GbButton
          type="button"
          gbTheme="bluePrimary"
          label="Save"
          @click="showDialog = false"
        ></GbButton>
      </template>
    </GbDialog>

    <Dialog>
      <DialogTrigger asChild>
        <GbButton gbTheme="grayOutlineSecondary" class="m-3">Open ShadCn Dialog (unstyled)</GbButton>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Dialog Title</DialogTitle>
          <DialogDescription>
            This dialog form content is using PrimeVue 3 components inside to demonstrate we can use both Reka/Shadcn components alongside PrimeVue 3 components.
          </DialogDescription>
        </DialogHeader>
        <form @submit.prevent>
          <div class="space-y-4">
            <div>
              <label for="name" class="block text-sm font-medium mb-2">Name</label>
              <InputText id="name" v-model="name" class="w-full" />
            </div>
            <div>
              <label for="email" class="block text-sm font-medium mb-2">Email</label>
              <InputText id="email" v-model="email" type="email" class="w-full" />
            </div>
            <div>
              <label for="category" class="block text-sm font-medium mb-2">Category</label>
              <Dropdown id="category" v-model="selectedCategory" :options="categories" optionLabel="name" placeholder="Select a category" class="w-full" />
            </div>
          </div>
        </form>
        <DialogFooter>
          <DialogClose as-child>
            <GbButton>Close</GbButton>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </div>
</template>
